import { buildModuleApi } from "../../../../../_CORE/API/_ApiUtil/_buildModuleApi";

const { API, PERMISSIONS, CONSTANTS, ENDPOINTS } = buildModuleApi({
    prefix: "AUTH", uri: "auth",
    exclude: ["LIST", "CREATE", "UPDATE", "REMOVE", "DETAIL", "ARCHIVE", "RESTORE", "ARCHIVED",
        "BULK_CREATE", "BULK_ARCHIVE", "BULK_RESTORE", "BULK_REMOVE_REQUEST", "BULK_REMOVE_CONFIRM"],
    withExtra: false,

    extraActions: {
        LOGIN: { suffix: "/login" },
        CHANGE_PASSWORD: { suffix: "/change-password" },
        VERIFY_PASSWORD: { suffix: "/verify-password" },
        VERIFY_TWO_FACTOR: { suffix: "/verify-2fa" },
        RESEND_TWO_FACTOR: { suffix: "/resend-2fa" },
    },

    overrides: {
        ME: { url: "/users/me" },
    },
});

export const AUTH_API = API;
export const AUTH_CONSTANTS = { ...CONSTANTS, ME: "AUTH__ME" };
export const AUTH_ENDPOINTS = { ...ENDPOINTS, AUTH__ME: "/users/me" };
export const AUTH_PERMISSIONS = PERMISSIONS;
